let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4iKOo")).then(() => parcelRequire('hofXv'));